// hooks/useSubscriptionDetails.js
import { useEffect, useState, useRef } from 'react';
import Axios from 'axios';

const useSubscriptionDetails = (user) => {
  const [subscriptionDetails, setSubscriptionDetails] = useState(null);
  const [userId, setUserId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const hasFetchedRef = useRef(false); // ✅ Tracks if fetch already triggered

  useEffect(() => {
    const fetchSubscriptionDetails = async () => {
      if (!user?.uid || hasFetchedRef.current) return;

      hasFetchedRef.current = true; // ✅ Mark fetch as done (only once per session)
      setUserId(user.uid);
      setLoading(true);

      try {
        const formData = new FormData();
        formData.append('request', 'getSubscriptionDetails');
        formData.append('userId', user.uid);
        formData.append('email', user.email);

        const URL = process.env.REACT_APP_BACKENDURL;

        const response = await Axios.post(URL, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
          withCredentials: true,
        });

        if (response.status === 200) {
          setSubscriptionDetails(response.data.data);
        }
      } catch (err) {
        console.error('Error fetching subscription details:', err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchSubscriptionDetails();
  }, [user?.uid, user?.email]); // ✅ Reacts only when user is defined

  return { subscriptionDetails, userId, loading, error };
};

export default useSubscriptionDetails;
